const packageData = [
    {
        id: 1,
        type: 'A',
        days: 5,
        destinations: 5,
        price: 1499,
        image: 'card1',
        routeName: '/package0'
    },
    {
        id: 2,
        type: 'C',
        days: 9,
        destinations: 9,
        price: 2499,
        image: 'card2',
        routeName: '/package2'
    },
    {
        id: 3,
        type: 'D',
        days: 11,
        destinations: 11,
        price: 2699,
        image: 'card3',
        routeName: '/package3'
    }
];

export default packageData;